import { makeStyles, Theme } from "@material-ui/core";
import { defaultContainer } from "styles/defaultStyle";

export const usePrivacyPolicyStyles = makeStyles((theme: Theme) => ({
  bgWhite: defaultContainer(theme),
}));
